export default __webpack_public_path__ + "static/media/darkSpinner.dcdfdac0.gif";